
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },
        {
  hid: 'description',
  name: 'description',
  content: 'Capture the beauty of Goa with the best photography experiences. From stunning beaches to vibrant streets, perfect for creating lasting memories.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Discover the best photography spots in Goa, from scenic landscapes to colorful local culture. Ideal for capturing unforgettable moments.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Explore Goa’s top photography spots and capture beautiful moments, from beaches to local life. Perfect for creating lasting memories!',
},

        {
          hid: 'keywords',
          name: 'keywords',
          content: 'goa best photography, best photography in goa, best beach for photography in goa, couple photography in goa, drone photography in goa, pre wedding photography in goa, best places for photography in goa, parra goa photography, professional photography in goa, vsnapu photography, vsnapu photography candolim, goa',
        },
       
      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
    {
      title: "Stunning Locations",
      text: "Capture breathtaking views and hidden gems with the best photography spots in Goa!",
    },
    {
      title: "Perfect for Everyone",
      text: "Whether you're a pro or just starting, there's something for every photography lover!",
    },
    {
      title: "Local Experts",
      text: "Our experienced photographers guide you to the best locations and give helpful tips.",
    },
    {
      title: "Easy Booking",
      text: "Book your perfect photography experience easily through the Goa App at great rates!",
    },
  ],

     
      title: 'Goa Best Photography - Professional Photographers in Goa',
    };
  },


  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-01-02T10%3A40%3A53.909Z2-%2814%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=dc86kfDsxRu2q%2FSOe4lJyFYOsks688ZyuMw7ecT1pVkvvSIqwtSxnJ%2BmJjPwekdXIaEyNCFXjhJJIaJ%2Fj5BCiLPvhD0x2A%2FVSL5uCnRv2efnciGyHvlN%2FulFIVfHeRu77mwjCHZEaVaN07SkZ32VNKz%2FwcCr%2B2zKNvmilWHAwRFMmD7YtI9oB9DBLs8c14yrqoK3WNPH1vrKIGBv7FzsCSCCPgNMNGyBJQ%2B7%2Bhm4%2FWlqP46yv%2By6G1hmF9xEvmck7CdLqN8QQsHAaBR%2F7CKuLZLKp9Wb8ht60DvVKjbHwdieSHNpds916zQTcA5v%2Fn5gqp6ZC%2B8XEhVr%2FwEdC1p3rQ%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-01-02T10%3A40%3A53.909Z2-%2814%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=dc86kfDsxRu2q%2FSOe4lJyFYOsks688ZyuMw7ecT1pVkvvSIqwtSxnJ%2BmJjPwekdXIaEyNCFXjhJJIaJ%2Fj5BCiLPvhD0x2A%2FVSL5uCnRv2efnciGyHvlN%2FulFIVfHeRu77mwjCHZEaVaN07SkZ32VNKz%2FwcCr%2B2zKNvmilWHAwRFMmD7YtI9oB9DBLs8c14yrqoK3WNPH1vrKIGBv7FzsCSCCPgNMNGyBJQ%2B7%2Bhm4%2FWlqP46yv%2By6G1hmF9xEvmck7CdLqN8QQsHAaBR%2F7CKuLZLKp9Wb8ht60DvVKjbHwdieSHNpds916zQTcA5v%2Fn5gqp6ZC%2B8XEhVr%2FwEdC1p3rQ%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-01-02T10%3A40%3A53.909Z2-%2814%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=dc86kfDsxRu2q%2FSOe4lJyFYOsks688ZyuMw7ecT1pVkvvSIqwtSxnJ%2BmJjPwekdXIaEyNCFXjhJJIaJ%2Fj5BCiLPvhD0x2A%2FVSL5uCnRv2efnciGyHvlN%2FulFIVfHeRu77mwjCHZEaVaN07SkZ32VNKz%2FwcCr%2B2zKNvmilWHAwRFMmD7YtI9oB9DBLs8c14yrqoK3WNPH1vrKIGBv7FzsCSCCPgNMNGyBJQ%2B7%2Bhm4%2FWlqP46yv%2By6G1hmF9xEvmck7CdLqN8QQsHAaBR%2F7CKuLZLKp9Wb8ht60DvVKjbHwdieSHNpds916zQTcA5v%2Fn5gqp6ZC%2B8XEhVr%2FwEdC1p3rQ%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/goa-best-photography`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/goa-best-photography`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-01-02T10%3A40%3A53.909Z2-%2814%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=dc86kfDsxRu2q%2FSOe4lJyFYOsks688ZyuMw7ecT1pVkvvSIqwtSxnJ%2BmJjPwekdXIaEyNCFXjhJJIaJ%2Fj5BCiLPvhD0x2A%2FVSL5uCnRv2efnciGyHvlN%2FulFIVfHeRu77mwjCHZEaVaN07SkZ32VNKz%2FwcCr%2B2zKNvmilWHAwRFMmD7YtI9oB9DBLs8c14yrqoK3WNPH1vrKIGBv7FzsCSCCPgNMNGyBJQ%2B7%2Bhm4%2FWlqP46yv%2By6G1hmF9xEvmck7CdLqN8QQsHAaBR%2F7CKuLZLKp9Wb8ht60DvVKjbHwdieSHNpds916zQTcA5v%2Fn5gqp6ZC%2B8XEhVr%2FwEdC1p3rQ%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-01-02T10%3A40%3A53.909Z2-%2814%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=dc86kfDsxRu2q%2FSOe4lJyFYOsks688ZyuMw7ecT1pVkvvSIqwtSxnJ%2BmJjPwekdXIaEyNCFXjhJJIaJ%2Fj5BCiLPvhD0x2A%2FVSL5uCnRv2efnciGyHvlN%2FulFIVfHeRu77mwjCHZEaVaN07SkZ32VNKz%2FwcCr%2B2zKNvmilWHAwRFMmD7YtI9oB9DBLs8c14yrqoK3WNPH1vrKIGBv7FzsCSCCPgNMNGyBJQ%2B7%2Bhm4%2FWlqP46yv%2By6G1hmF9xEvmck7CdLqN8QQsHAaBR%2F7CKuLZLKp9Wb8ht60DvVKjbHwdieSHNpds916zQTcA5v%2Fn5gqp6ZC%2B8XEhVr%2FwEdC1p3rQ%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/goa-best-photography`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Goa App Blog",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "Goa Best Photography - Book @ ₹4999 Flat 17% Off",
  "description": "Enjoy the best photography experience in Goa with stunning landscapes, vibrant culture, and unique moments captured for an unforgettable visual journey..",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-01-02T10%3A40%3A53.909Z2-%2814%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=dc86kfDsxRu2q%2FSOe4lJyFYOsks688ZyuMw7ecT1pVkvvSIqwtSxnJ%2BmJjPwekdXIaEyNCFXjhJJIaJ%2Fj5BCiLPvhD0x2A%2FVSL5uCnRv2efnciGyHvlN%2FulFIVfHeRu77mwjCHZEaVaN07SkZ32VNKz%2FwcCr%2B2zKNvmilWHAwRFMmD7YtI9oB9DBLs8c14yrqoK3WNPH1vrKIGBv7FzsCSCCPgNMNGyBJQ%2B7%2Bhm4%2FWlqP46yv%2By6G1hmF9xEvmck7CdLqN8QQsHAaBR%2F7CKuLZLKp9Wb8ht60DvVKjbHwdieSHNpds916zQTcA5v%2Fn5gqp6ZC%2B8XEhVr%2FwEdC1p3rQ%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "4999",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/goa-best-photography",
        "url": "https://www.goa.app/goa-best-photography",
        "name": "Goa Best Photography",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-01-02T10%3A40%3A53.909Z2-%2814%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=dc86kfDsxRu2q%2FSOe4lJyFYOsks688ZyuMw7ecT1pVkvvSIqwtSxnJ%2BmJjPwekdXIaEyNCFXjhJJIaJ%2Fj5BCiLPvhD0x2A%2FVSL5uCnRv2efnciGyHvlN%2FulFIVfHeRu77mwjCHZEaVaN07SkZ32VNKz%2FwcCr%2B2zKNvmilWHAwRFMmD7YtI9oB9DBLs8c14yrqoK3WNPH1vrKIGBv7FzsCSCCPgNMNGyBJQ%2B7%2Bhm4%2FWlqP46yv%2By6G1hmF9xEvmck7CdLqN8QQsHAaBR%2F7CKuLZLKp9Wb8ht60DvVKjbHwdieSHNpds916zQTcA5v%2Fn5gqp6ZC%2B8XEhVr%2FwEdC1p3rQ%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-01-02T10%3A40%3A53.909Z2-%2814%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=dc86kfDsxRu2q%2FSOe4lJyFYOsks688ZyuMw7ecT1pVkvvSIqwtSxnJ%2BmJjPwekdXIaEyNCFXjhJJIaJ%2Fj5BCiLPvhD0x2A%2FVSL5uCnRv2efnciGyHvlN%2FulFIVfHeRu77mwjCHZEaVaN07SkZ32VNKz%2FwcCr%2B2zKNvmilWHAwRFMmD7YtI9oB9DBLs8c14yrqoK3WNPH1vrKIGBv7FzsCSCCPgNMNGyBJQ%2B7%2Bhm4%2FWlqP46yv%2By6G1hmF9xEvmck7CdLqN8QQsHAaBR%2F7CKuLZLKp9Wb8ht60DvVKjbHwdieSHNpds916zQTcA5v%2Fn5gqp6ZC%2B8XEhVr%2FwEdC1p3rQ%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-01-02T10%3A40%3A53.909Z2-%2814%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=dc86kfDsxRu2q%2FSOe4lJyFYOsks688ZyuMw7ecT1pVkvvSIqwtSxnJ%2BmJjPwekdXIaEyNCFXjhJJIaJ%2Fj5BCiLPvhD0x2A%2FVSL5uCnRv2efnciGyHvlN%2FulFIVfHeRu77mwjCHZEaVaN07SkZ32VNKz%2FwcCr%2B2zKNvmilWHAwRFMmD7YtI9oB9DBLs8c14yrqoK3WNPH1vrKIGBv7FzsCSCCPgNMNGyBJQ%2B7%2Bhm4%2FWlqP46yv%2By6G1hmF9xEvmck7CdLqN8QQsHAaBR%2F7CKuLZLKp9Wb8ht60DvVKjbHwdieSHNpds916zQTcA5v%2Fn5gqp6ZC%2B8XEhVr%2FwEdC1p3rQ%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "Best Photography in Goa captures the stunning beaches, vibrant culture, and scenic landscapes. It’s an ideal destination for photography enthusiasts looking to frame beautiful sunsets, historic sites, and lush greenery.",
        "breadcrumb": {
            "@id": "https://www.goa.app/goa-best-photography/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/goa-best-photography"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
    "@type": "Question",
    "name": "What are the best photography spots in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Some of the best photography spots in Goa include Candolim Beach, Vagator Fort, Chapora Fort, and the vibrant streets of Fontainhas."
    }
  },
  {
    "@type": "Question",
    "name": "What types of photography services are available in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "In Goa, you can find various photography services, including couple shoots, pre-wedding photography, drone photography, and professional event photography."
    }
  },
  {
    "@type": "Question",
    "name": "How much does a photography session cost in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Photography sessions in Goa typically start from ₹4,999, depending on the location and package chosen."
    }
  },
  {
    "@type": "Question",
    "name": "Can I book a photographer for a special event in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, many photographers in Goa offer customizable packages for special events such as weddings, birthdays, and corporate functions."
    }
  },
  {
    "@type": "Question",
    "name": "What is the best time for photography in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "The best time for photography in Goa is during the golden hours, shortly after sunrise and before sunset, to capture stunning lighting."
    }
  },
  {
    "@type": "Question",
    "name": "Are there any restrictions on photography at certain locations?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, some locations in Goa may have restrictions on photography, especially private properties or during specific events. Always check beforehand."
    }
  },
  {
    "@type": "Question",
    "name": "Do photography packages include editing services?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Most photography packages in Goa include basic editing services, but you can also request additional retouching for an extra fee."
    }
  },
  {
    "@type": "Question",
    "name": "Can I choose my photography locations?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Absolutely! Many photographers will work with you to choose locations that match your vision and preferences."
    }
  },
  {
    "@type": "Question",
    "name": "What should I wear for a photography session in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Choosing comfortable and vibrant outfits that complement the scenery is recommended. Light fabrics and bright colors work well in Goa's sunny climate."
    }
  },
  {
    "@type": "Question",
    "name": "How do I book a photography session in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "You can book a photography session in Goa through various platforms, including the Goa App, where you can find reputable photographers and package details."
    }
    }
        ]
      }
    ]
  };
},


};



  